<template>

      <router-view></router-view>
 
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "viewGamesIndex",
});
</script>

<style lang="scss" scoped>
// @import "@/assets/scss/global.scss";
</style>
